import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import AdminConsoleDataTable from "../AdminConsoleDataTable";
import fetchData from "../../../../axios/fetchData";
import CustomLoader from "../../../../component/Loader/Loader";
import { users } from "../../../../axios/serverUrl";

const TenantAdmins = ({ buildingList }) => {
  const navigator = useNavigate();
  const [tenantAdminsTableJson, setTenantAdminsTableJson] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (JSON.parse(localStorage.userDetail)?.authority !== "TENANT_ADMIN") {
      return;
    } 
    fetchTenantAdmins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchTenantAdmins = async () => {
    try {
      setLoading(true);

      let page = 0;
      const pageSize = 100;
      let hasNext = true;
      let allAdmins = [];

      while (hasNext) {
        const response = await fetchData(
          "GET",
          `${users}?page=${page}&pageSize=${pageSize}&sortProperty=createdTime&sortOrder=DESC`,
          {
            "X-Authorization": `Bearer ${localStorage.getItem("token")}`,
          }
        );

        if (response?.data) {
          const admins = response.data.filter(
            (u) => u.authority === "TENANT_ADMIN"
          );
          allAdmins = [...allAdmins, ...admins];

          hasNext = response.hasNext;
          page++;
        } else if (response?.errorCode === 11) {
          hasNext = false;
          navigator("/login");
          localStorage.clear();
        } else {
          hasNext = false;
        }
      }

      setAllData(allAdmins);
    } catch (error) {
      console.error("Error fetching tenant admins:", error);
    }
  };

  const setAllData = (response) => {
    if (response) {
      const tenantAdminsTableJson = response?.map((tenantAdminData) => ({
        firstName: tenantAdminData.firstName,
        lastName: tenantAdminData.lastName,
        email: tenantAdminData.email,
        thingsboardId: tenantAdminData.id.id,
        createdTime: tenantAdminData.createdTime,
      }));
      setTenantAdminsTableJson(tenantAdminsTableJson);
      setLoading(false);
    } else if (response.errorCode === 11) {
      navigator("/login");
      localStorage.clear();
    }
  };

  return (
    <div>
      <AdminConsoleDataTable
        tableHeadings={[
          "First name",
          "Last name",
          "Email",
          "Thingsboard ID",
          "Created time",
        ]}
        tableJson={tenantAdminsTableJson}
        type="tenantAdmins"
        defaultSortAsc={false}
        defaultSortFieldId="createdAt"
      />

      <CustomLoader
        idLoading={isLoading}
        handleLoading={() => setLoading(!isLoading)}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  buildingList: state.buildingList.buildingList,
});
export default connect(mapStateToProps, {})(TenantAdmins);
